import React, { FC, ReactNode } from 'react';
import { MaterialIcon, MaterialIconProps } from './';

import './MaterialIconText.scss';

interface MaterialIconsTextProps extends MaterialIconProps {
  readonly children?: ReactNode;
}

export const MaterialIconText: FC<MaterialIconsTextProps> = ({ children, ...props }) => {
  return (
    <div className="material-icon-text">
      <MaterialIcon {...props} />
      <div>{children}</div>
    </div>
  );
};
